var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnnotation = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 1.5C0.671573 1.5 0 2.17157 0 3V16.5C0 17.3284 0.671573 18 1.5 18H7.31805L11.1213 21.8033C11.7071 22.3891 12.6569 22.3891 13.2427 21.8033L17.046 18H22.5C23.3284 18 24 17.3284 24 16.5V3C24 2.17157 23.3284 1.5 22.5 1.5H1.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnnotation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/annotation.d439661370a9b16b4be21ad7c0dfe974.svg";